import {
    Component,
    EventEmitter,
    Input,
    OnDestroy,
    Output
} from '@angular/core';
import { ValueMetricPaywallType } from '../../constants-types';
import {
    ModuleName,
    IDynamicallyCreatedComponent,
    PartnerInformation
} from '../../core-data-model';
import { TranslationService } from '../../translations';

export type ValueMetricsPaywallModalConfig = {
    titleKey: string;
    bodyTextMap: Map<ValueMetricPaywallType, string>;
    partnerInformation: PartnerInformation;
    isConvertSelfServe: boolean;
    module: ModuleName;
    metricName: string;
    metricsConsumed: number;
};

@Component({
    styles: [
        '.paywallModalTitle { margin-top: 20px;}',
        '.paywallModalBodyText { padding: 10px 30px 0px 30px;}',
        '.paywallModalPartnerName { margin-top: 20px; text-transform: uppercase;}'
    ],
    template: `
        <div class="value-metrics-head-no-teams"></div>
        <div class="pi-modalBody_simpleText">
            <div
                class="title-md paywallModalTitle"
                piTesting="value-metrics-title"
            >
                {{ TR.key(config.titleKey) }}
            </div>
            <div
                class="copy-lg paywallModalBodyText"
                [innerHTML]="modalBodyText"
            ></div>
            <div class="span-bold copy-md paywallModalPartnerName">
                {{ config.partnerInformation.fullName }}
            </div>
            <div class="value-metrics-partner-email copy-md">
                {{ config.partnerInformation.email }}
            </div>
        </div>
        <div class="pi-modalFooter">
            <div class="btn--lsg_centeredContainer">
                <button
                    type="button"
                    class="button button-md  button-tertiary"
                    data-tracking="valueMetricsPaywallCancelButton"
                    piTesting="value-metrics-cancel"
                    (click)="confirmRequest(false)"
                >
                    {{ TR.key(getBackButtonText()) }}
                </button>
                <a [href]="'mailto:' + config.partnerInformation.email">
                    <button
                        type="button"
                        class="button button-md button-primary"
                        data-tracking="valueMetricsPaywallEmailButton"
                        piTesting="value-metrics-email"
                        (click)="confirmRequest(true)"
                    >
                        {{ TR.key('value-metrics.modal.sendAnEmail') }}
                    </button>
                </a>
            </div>
        </div>
    `,
    standalone: false
})
export class ValueMetricsPaywallModalComponent
    implements IDynamicallyCreatedComponent, OnDestroy
{
    @Output()
    readonly confirm = new EventEmitter();

    @Input() paywallType: ValueMetricPaywallType;
    @Input() config: ValueMetricsPaywallModalConfig;

    outputEvents = ['confirm'];
    subscriptions: any[];

    get propertiesList(): string[] {
        return ['config', 'paywallType'];
    }

    constructor(public TR: TranslationService) {}

    get modalBodyText(): string {
        return this.config.bodyTextMap.get(this.paywallType);
    }

    confirmRequest(isConfirmed: boolean) {
        this.confirm.emit(isConfirmed);
    }

    ngOnDestroy() {
        if (this.subscriptions) {
            this.subscriptions.forEach((subscription) => {
                subscription.unsubscribe();
            });
        }
    }

    getBackButtonText(): string {
        return this.config.isConvertSelfServe
            ? 'label.common-terms.cancel'
            : 'label.common-terms.back';
    }
}
